import React, { useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/dist/styles.css";
import { Maybe } from '../../types/types';
import getSlides from '../../utils/getSlides';
import styles from './Gallery.module.scss';

interface GalleryProps {
    photos: Maybe<string[]>
}

export default function Gallery(props: GalleryProps) {

    const { photos } = props
    const slides = getSlides(photos)

    const [open, setOpen] = useState<boolean>(false)
    const [startIndex, setStartIndex] = useState<number>(0)

    const handleClick = (index: number) => {
        setStartIndex(index)
        setOpen(true)
    }

    return (
        <div>
            <Carousel showThumbs={false} showArrows={false} swipeable autoPlay infiniteLoop showStatus={false}>
                {photos?.map((photo: any, index: number) => (
                    <div key={index} onClick={() => handleClick(index)} className={styles.Slide}>
                        <img src={photo} alt="" />
                    </div>
                ))}
            </Carousel>
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                index={startIndex}
                slides={slides}
                carousel={{
                    finite: true
                }}
                className={styles.LightBox}
            />

        </div>
    )
}


